import React from 'react';

const AlertDot = ({ isRead }) => {
  return (
    <span
      className={`
        inline-block w-5 h-5 rounded-full 
        ${isRead ? 'bg-gray-500' : 'bg-blue-500'} 
        text-center leading-5 text-white
      `}
    />
  );
};

export default AlertDot;
